import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ProjectService, CommonService, FileService } from '../../../_services/';

import * as fileSaver from 'file-saver';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pmfdl',
  templateUrl: './pmfdl.component.html',
  styleUrls: ['./pmfdl.component.scss']
})
export class PmfdlComponent implements OnInit {
  files:any[] =[];
  fieldId:String='';
  projectId:String='';
  projectData:any;
  fieldName : String = '';
  private subscription: Subscription;
  private subscription2: Subscription;
  constructor(
    private _project : ProjectService,
    private _common : CommonService,
    private route : ActivatedRoute,
    private _file : FileService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.fieldId = params.get("id");
      this.projectId = params.get("project_id");
    })
    this.getProjectById();
    this.getFileFields();
  }

  getFileFields(){
    this._common.showLoader(true);
    this.subscription = this._project.getFileFields(this.fieldId, this.projectId).subscribe(res =>{
      this._common.showLoader(false);
      this.files = res.map(item=>{ const obj:any = item.payload.doc.data(); obj.fileName= decodeURIComponent(obj.fbs_download_url).split('?')[0].split('/').reverse()[0]; return obj; });
      this.subscription2 = this._project.getFileFieldName(this.fieldId).subscribe(res2 =>{
      this.fieldName = res2[0].payload.doc.data()['name'];
    },error=>{
      console.log('Something went wrong!');
    })
    },error=>{
      console.log('Something went wrong!');
    });
  }

  getProjectById(){
      this.subscription2 = this._project.getProjectDataById(this.projectId).subscribe((res:any) =>{
        this.projectData = res.payload.data(); 
        console.log(this.projectData,'res payload data');
      },error=>{
        console.log('Something went wrong!');
      });
  
  }

  download(url) {
    this._file.downloadFile(url).subscribe(response => {
			let blob:any = new Blob([response.blob()], { type: 'text/json; charset=utf-8' });
      const decodedUrl = decodeURIComponent(url);
      // console.log(decodedUrl,'decodedUrl')
      fileSaver.saveAs(blob, `${decodedUrl.split('?')[0].split('/').reverse()[0]}`); // download.${url.split('?')[0].split('').reverse()[0]}
     // fileSaver.saveAs(blob, `download.${url.split('?')[0].split('').reverse()[0]}`); // old approach
		}), error => console.log('Error downloading the file'),
                 () => console.info('File downloaded successfully'); 
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
  }

}
